
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"xmlns":"http://www.w3.org/2000/svg","width":"40","height":"40"}, attrs),
              ...rest,
            },
            children.concat([_c('g',{attrs:{"fill":"none","fill-rule":"evenodd","transform":"translate(6 6)"}},[_c('path',{attrs:{"fill":"#CCE8FF","d":"M2 18h24v10H2z"}}),_c('rect',{attrs:{"width":"26","height":"26","x":"1","y":"1","stroke":"#2196F3","stroke-width":"2","rx":"2"}}),_c('path',{attrs:{"fill":"#2196F3","d":"M4 9h20v2H4zM4 18h20v2H4z"}}),_c('rect',{attrs:{"width":"6","height":"6","x":"14","y":"7","fill":"#FFF","stroke":"#2196F3","stroke-width":"2","rx":"3"}}),_c('rect',{attrs:{"width":"6","height":"6","x":"8","y":"16","fill":"#FFF","stroke":"#2196F3","stroke-width":"2","rx":"3"}})])])
          )
        }
      }
    